module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fmtitle"
  }, [_c('a', {
    attrs: {
      "id": "page_v"
    }
  }), _vm._v("CONTENTS")]), _vm._v(" "), _c('table', {
    attrs: {
      "cellpadding": "0",
      "cellspacing": "0",
      "width": "100%"
    }
  }, [_c('colgroup', [_c('col', {
    attrs: {
      "width": "20%"
    }
  }), _vm._v(" "), _c('col', {
    attrs: {
      "width": "80%"
    }
  })]), _c('tbody', [_c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/06_Acknowledgement"
    }
  }, [_c('i', [_vm._v("Acknowledgments")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toca"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/07_Introduction"
    }
  }, [_vm._v("Introduction")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tocs"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/08_Chapter01"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CHAPTER 1")]), _vm._v(".")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/08_Chapter01"
    }
  }, [_vm._v("George Woodward Morse")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tocs"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/09_Chapter02"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CHAPTER 2")]), _vm._v(".")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/09_Chapter02"
    }
  }, [_vm._v("Morse’s Early Patents")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tocs"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/10_Chapter03"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CHAPTER 3")]), _vm._v(".")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/Text/10_Chapter03"
    }
  }, [_vm._v("Nathan M. Muzzy")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tocs"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/11_Chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CHAPTER 4")]), _vm._v(".")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/11_Chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("War Department Evaluations, 1857–1858")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tocs"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/12_Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CHAPTER 5")]), _vm._v(".")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/12_Chapter05",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Springfield Armory")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tocs"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/13_Chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CHAPTER 6")]), _vm._v(".")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/13_Chapter06",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Morse’s New Carbine, 1860")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tocs"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/14_Chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CHAPTER 7")]), _vm._v(".")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/14_Chapter07",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Morse in Late 1860 and Early 1861")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tocs"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/15_Chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CHAPTER 8")]), _vm._v(".")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/15_Chapter08",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Harpers Ferry, Nashville, and Atlanta")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tocs"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/16_Chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CHAPTER 9")]), _vm._v(".")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/16_Chapter09",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("South Carolina State Military Works and David Lopez Jr.")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tocs"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/17_Chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CHAPTER 10")]), _vm._v(".")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/17_Chapter10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1862")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tocs"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/18_Chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CHAPTER 11")]), _vm._v(".")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/18_Chapter11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Morse Comes to South Carolina")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tocs"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/19_Chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CHAPTER 12")]), _vm._v(".")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/19_Chapter12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Labor")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tocs"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/20_Chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CHAPTER 13")]), _vm._v(".")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/20_Chapter13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1863")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tocs"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/21_Chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CHAPTER 14")]), _vm._v(".")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/21_Chapter14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Lopez’s Resignation and Successor")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tocs"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/22_Chapter15",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CHAPTER 15")]), _vm._v(".")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/22_Chapter15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Morse’s Brass-frame Carbine")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tocs"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/23_Chapter16",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CHAPTER 16")]), _vm._v(".")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/23_Chapter16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sale of the State Works")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tocs"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/24_Chapter17",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CHAPTER 17")]), _vm._v(".")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/24_Chapter17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Late 1863 and 1864")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tocs"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/25_Chapter18",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CHAPTER 18")]), _vm._v(".")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/25_Chapter18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1865")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tocs"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/26_Chapter19",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CHAPTER 19")]), _vm._v(".")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/26_Chapter19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("State Military Works and Lopez, Postwar")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tocs"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/27_Chapter20",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CHAPTER 20")]), _vm._v(".")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/27_Chapter20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Morse’s Postwar Patent Petitions and Lawsuits")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "tocs"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/28_Chapter21",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "small"
  }, [_vm._v("CHAPTER 21")]), _vm._v(".")])])]), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/28_Chapter21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Morse’s Final Productivity")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/29_Conclusion",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Conclusion")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1t"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/30_Appendix01",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Appendix 1")]), _vm._v(". Inventory of Machinery, Tools, and Stock of Tennessee Armory, Atlanta, March 1862")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/31_Appendix02",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Appendix 2")]), _vm._v(". Surviving Morse Firearms Listed by Serial Number")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/32_Appendix03",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Appendix 3")]), _vm._v(". List of Slave Workers")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('a', {
    attrs: {
      "id": "page_vi"
    }
  }), _c('span', {
    attrs: {
      "href": "#/Text/33_Appendix04",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Appendix 4")]), _vm._v(". List of White Employees")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/34_Appendix05",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Appendix 5")]), _vm._v(". Total Production of Morse’s Firearms")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/35_Notes",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Notes")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/36_Bibliography",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Bibliography")])])])])]), _vm._v(" "), _c('tr', [_c('td', {
    attrs: {
      "valign": "top"
    }
  }), _vm._v(" "), _c('td', {
    attrs: {
      "valign": "top"
    }
  }, [_c('p', {
    staticClass: "toc1"
  }, [_c('span', {
    attrs: {
      "href": "#/Text/37_Index01",
      "title": "Link target outside of Sample"
    }
  }, [_c('i', [_vm._v("Index")])])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ba250738","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/05_Contents.vue
// module id = 69
// module chunks = 0